import React from 'react';
import BannersComponents from 'legacyfrontend/components/home/BannersComponents';

export const SearchSelectorSkeleton = ({ shouldShowBanners }) => (
  <>
    <div className='stacked__container'>
      <div className='absolute bottom-0 w-full flex justify-center px-2 -mt-4 z-[1] md:bottom-[2rem] md:px-[15vw] md:-mt-0'>
        <div className='w-full max-w-[400px] md:max-w-none rounded-xl bg-white/90 shadow-lg p-4 animate-pulse'>
          <div className='h-12 rounded-xl bg-gray-200 md:hidden' />
          <div className='hidden md:flex items-end gap-4'>
            <div className='h-10 flex-1 rounded bg-gray-200' />
            <div className='h-10 flex-1 rounded bg-gray-200' />
            <div className='h-10 flex-1 rounded bg-gray-200' />
            <div className='h-10 w-28 rounded bg-gray-300' />
          </div>
        </div>
      </div>
    </div>
    {shouldShowBanners && <BannersComponents />}
  </>
);
